import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/CustomChatButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlassRuntime"] */ "/vercel/path0/app/components/providers/GlassRuntime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/TawkLazyLoader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/tailwind.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/vercel/path0/node_modules/swr/dist/index/config-12s-Bi4rgVRk.mjs");
